<template>
    <y-heading :level="1" variant="page" class="mb-8">
        <slot/>
    </y-heading>
</template>
